import { advantages } from '@/mocks/home';

export default function CTASection() {
  return (
    <section id="register" className="relative py-14 md:py-20 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20dark%20sports%20theme%20background%20with%20subtle%20geometric%20patterns%20and%20warm%20golden%20accent%20light%20rays%2C%20premium%20atmosphere%2C%20minimal%20abstract%20design%2C%20dark%20gradient%20with%20depth&width=1800&height=800&seq=cta-bg-2026&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-secondary-900/92"></div>
      </div>

      <div className="relative z-10 mx-auto px-4 md:px-6 max-w-7xl">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50 mb-3">
            加入皇冠体育，开启专业投注之旅
          </h2>
          <p className="text-foreground-400 text-sm md:text-base max-w-xl mx-auto">
            四大核心优势，为您提供最优质的体育博彩体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6 mb-10 md:mb-14">
          {advantages.map((adv) => (
            <div
              key={adv.title}
              className="p-5 md:p-6 rounded-xl bg-background-50/5 border border-background-50/10 hover:border-accent-500/40 hover:bg-background-50/8 transition-all duration-300 text-center"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 mx-auto flex items-center justify-center rounded-xl bg-accent-500/15 mb-4">
                <i className={`${adv.icon} text-accent-400 text-xl md:text-2xl`}></i>
              </div>
              <h3 className="font-heading text-base font-semibold text-background-50 mb-2">
                {adv.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-400 leading-relaxed">
                {adv.description}
              </p>
            </div>
          ))}
        </div>

        <div className="text-center">
          <a
            href="#"
            className="inline-flex whitespace-nowrap items-center gap-2 px-10 py-4 rounded-xl bg-accent-500 text-background-50 font-semibold text-base hover:bg-accent-600 transition-all duration-300 cursor-pointer"
          >
            立即注册皇冠体育
            <i className="ri-arrow-right-line"></i>
          </a>
          <p className="mt-4 text-xs text-foreground-500">
            新用户注册即享专属优惠，首存赠送100%彩金
          </p>
        </div>
      </div>
    </section>
  );
}